<div class="quotation-order-content container-fluid container-lg py-3" [ngClass]="{'loader-blur': isLoading}">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="improved-page-label">View Quotation</div>
      <button *ngIf="isAccessTokenPresent" (click)="GoToDashboard()" class="btn btn-primary improved-add-btn">Go to Dashboard</button>
    </div>
    <div class="quotation-order-cards mt-3 row" [ngClass]="{'blur-class': !isAccessTokenPresent}" *ngIf="dataFetch">
      <div class="col-12">
        <div class="d-flex justify-content-between mb-3 w-100 align-items-center">
          <div class="heading-1">Pricing Details</div>
          <div id="quotation-manufacturing-engineering-status" class="quotation-manufacturing-mquote"> MANUFACTURING </div>
        </div>
         <div>
          <table class="table table-bordered quotation-table">
            <thead class="quotation-table-new">
                <tr class="table-header">
                    <th class="header-Particulars">Particulars</th>
                    <th *ngFor="let col of quotationViewDetails">Quantity ({{ col.qty }})</th>
                </tr>

            </thead>
            <tbody>
                <!-- Part A - RMC -->
                <tr (click)="toggleSection('partA')" class="clickable">
                  <td class="section-header">
                    <span class="material-symbols-rounded">
                      {{ isPartAOpen ? 'expand_more' : 'chevron_right' }} <span>Part - A - RMC</span>
                    </span>
                  </td>
                  <td class="section-header" *ngFor="let total of totalPartAForEachRow">${{  total | number: '1.4-4' }}</td>
                </tr>
                <ng-container *ngIf="isPartAOpen">
                  <tr>
                    <td class="Particulars-title">Basic eBOM Cost</td>
                    <td *ngFor="let cost of totalFinalCosts; let i = index">
                      ${{ cost?.part1rmccost?.totalEbomCost | number: '1.4-4' }}
                  
                      <!-- Ensure you're accessing the correct row -->
                      <ng-container *ngIf="(getRemainingMPNPrice(i) ?? []).length > 0">
                        <span>
                          <button class="btn missing-comp-btn" (click)="openModal(openMissingComp, i)">
                            <span class="view-missing-comp">
                              <img [src]="getImagePath + 'info.svg'" alt="" width="14"> 
                            </span>
                          </button>
                        </span>
                      </ng-container>
                      <div class="per-unit-specification-value"> (${{ cost?.part1rmccost?.totalEbomUnitPrieCost | number: '1.4-4' }}) <span class="per-unit-specification-title">total unit cost</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Bare PCB Cost - Per Sq. mm</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalBarePcbCost | number: '1.4-4' }}</td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Freight Cost</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalFreightCost | number: '1.4-4' }}</td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Insurance Cost</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalInsuranceCost | number: '1.4-4' }}</td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Duties for Parts</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalDutiesPartsPCBCost | number: '1.4-4' }}</td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Clearing Charges</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalClearingBankChargeCost | number: '1.4-4' }}</td>
                  </tr>
                  <tr>
                    <td class="Particulars-title">Mortality</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part1rmccost?.totalMortalityCost | number: '1.4-4' }}</td>
                  </tr>
              </ng-container>
                <!-- Part B - Process Cost -->
                <tr  (click)="toggleSection('partB')" class="clickable">
                    <td class="section-header"><span class="material-symbols-rounded">
                      {{ isPartBOpen ? 'expand_more' : 'chevron_right' }}
                  <span>Part-B-Process Cost</span></span></td>
                    <td class="section-header" *ngFor="let total of totalPartBForEachRow">${{ total | number: '1.4-4'  }}</td>
                </tr>
                <ng-container *ngIf="isPartBOpen">
                <tr>
                    <td class="Particulars-title">PCB Assembly Cost/SMT</td>
                    <td *ngFor="let cost of totalFinalCosts; let i = index">
                      ${{ cost?.part2processcost?.totalSMTThroughHoleCost | number: '1.4-4' }}
                    </td>
                </tr>
                <tr>
                  <td class="Particulars-title d-flex align-items-center justify-content-between">Testing Cost (Per Minutes)
                    <input type="number" class="form-control input-placeholder" placeholder="Enter Value"
                           [(ngModel)]="testingInput" (keyup)="calculateTestingCost()" (input)="restrictInput($event)" />
                  </td>
                  <td *ngFor="let cost of totalFinalCosts; let i = index">
                    ${{ calculateTestingCost(i) | number: '1.4-4' }}
                  </td>
                </tr>
                <tr>
                    <td class="Particulars-title d-flex align-items-center justify-content-between">X-Ray (Only for BGA Parts)
                      <input type="number" class="form-control input-placeholder" placeholder="Enter Value"
                      [(ngModel)]="packagingInput" (keyup)="calculateXRayCost()" (input)="restrictInput($event)" />
                    </td>
                    <td *ngFor="let cost of totalFinalCosts; let i = index">
                      ${{ calculateXRayCost(i) | number: '1.4-4' }}
                    </td>
                </tr>
                <tr>
                    <td class="Particulars-title">Packaging Box PCBA (Corrugated Box, Holy-ESD Poly Bag, ESD Form, Carton Box)</td>
                    <td  *ngFor="let cost of totalFinalCosts">${{ cost?.part2processcost?.totalpackagingBoxPCBACost | number: '1.4-4'}}</td>
                </tr>
              </ng-container>
                <!-- Part C - Others -->
                <tr (click)="toggleSection('partC')" class="clickable">
                    <td class="section-header"> <span class="material-symbols-rounded">
                      {{ isPartCOpen ? 'expand_more' : 'chevron_right' }}
                  <span>Part-C-Others</span></span></td>
                    <td class="section-header" *ngFor="let total of totalPartCForEachRow">${{ total  | number: '1.4-4' }}</td>
                </tr>
                <ng-container *ngIf="isPartCOpen">
                <tr>
                    <td class="Particulars-title d-flex align-items-center justify-content-between">Inventory Carrying Cost (Per Month)
                      <input type="number" class="form-control input-placeholder" placeholder="Enter Value"
                      [(ngModel)]="inventoryInput" (keyup)="calculateinventoryCost()" (input)="restrictInput($event)" />
                    </td>
                    <td *ngFor="let cost of totalFinalCosts ; let i = index">${{ calculateinventoryCost(i)  | number: '1.4-4'}}</td>
                </tr>
                <tr>
                    <td class="Particulars-title">Overheads</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part3others?.totaloverheadsCost | number: '1.4-4' }}</td>
                </tr>
                <tr>
                    <td class="Particulars-title">Markup</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part3others?.totalmarkupCost | number: '1.4-4' }}</td>
                </tr>
              </ng-container>
                <!-- Part D - One time NRE -->
                <tr  (click)="toggleSection('partD')" class="clickable">
                    <td class="section-header"><span class="material-symbols-rounded">
                      {{ isPartDOpen ? 'expand_more' : 'chevron_right' }}
                    <span>Part-D-Onetime NRE</span></span></td>
                    <td *ngFor="let total of totalPartDForEachRow" class="section-header">${{  total | number: '1.4-4' }}</td>
                </tr>
                <ng-container *ngIf="isPartDOpen">
                <tr>
                    <td class="Particulars-title">Bare PCB Cost - Tooling NRE 
                      <span *ngIf="totalfinalcost?.part4onetimenre?.layerSize < 6">(+30% Duty)</span></td>
                    <td *ngFor="let cost of totalFinalCosts"> ${{ bareMinimum(cost?.part4onetimenre?.totalbarePCBToolingNRECost) | number: '1.4-4' }}</td>
                </tr>
                <tr>
                    <td class="Particulars-title">NRE (Line & Machine)</td>
                    <td *ngFor="let cost of totalFinalCosts">${{ cost?.part4onetimenre?.totallineMachineNRECost | number: '1.4-4'}}</td>
                </tr>
                <tr>
                    <td class="border-color-table Particulars-title">NRE Stencil(High Quantity)</td>
                    <td *ngFor="let cost of totalFinalCosts" class="border-color-table">${{ cost?.part4onetimenre?.totalstensilNRECost | number: '1.4-4'}}</td>
                </tr>
              </ng-container>
                <!-- Final Totals -->
                <tr class="total-row no-border">
                  <td colspan="1" class="text-end">Selling Price <span class="inc-exc"> ("Excluding NRE, Ex-works")</span></td>
                  <td *ngFor="let total of sellingTotalForEachRow" class="price-color">${{total | number: '1.4-4' }}</td>
              </tr>
              <tr class="total-row no-border">
                  <td colspan="1" class="text-end">Final Price  <span class="inc-exc"> (Inclusive All)</span></td>
                  <td *ngFor="let total of finalTotalForEachRow" class="price-color">${{ total | number: '1.4-4' }}</td>
              </tr>
            </tbody>
        </table>
      </div>
      </div>

      <ng-template #openMissingComp let-c="close" let-d="dismiss">
        <div class="modal-content">
          <div class="modal-header improved-cof-modal-header">
            <h4 class="modal-title" id="modal-basic-title">Missing Components Price</h4>
            <button type="button" class="btn-close close custom-close-button" aria-label="Close" (click)="d('Cross click')"></button>
          </div>
          <div class="modal-body improved-cof-modal-body">
            <table *ngIf="remainingMPNPrice?.length > 0" class="table table-bordered quotation-missing-table">
              <thead>
                <tr class="table-active">
                  <th>MPN</th>
                  <th>Manufacturer</th>
                  <th>Quantity</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let remainingPrice of remainingMPNPrice">
                  <td>{{remainingPrice.MPN}}</td>
                  <td>{{remainingPrice.Manufacturer}}</td>
                  <td>{{remainingPrice.Quantity}}</td>
                  <td>{{remainingPrice.Description}}</td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="remainingMPNPrice?.length == 0" class="mb-4">No missing component.</div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

